import { Injectable } from '@angular/core';
import {ConductorDTO} from "../../dtos/conductor.dto";

@Injectable({
  providedIn: 'root'
})
export class ConductorService {

  private conductorSeleccionado: ConductorDTO;

  constructor() {

  }

  getConductorSeleccionado() {
    return this.conductorSeleccionado;
  }

  setConductorSeleccionado(movil: ConductorDTO) {
    this.conductorSeleccionado = movil;
  }

}
